export const metaConfig = ({ client }) => ({
  HTTPMethod: "get",
  path: `/metadata/${client}/profile/meta.json`,
  headers: {},
  body: {},
});
